<script>
import TopBlock from "@/components/HomePageView/TopBlock.vue";
import ShopList from "@/components/HomePageView/ShopList.vue";
import ClubNews from "@/components/HomePageView/ClubNews.vue";
import SeminarList from "@/components/HomePageView/SeminarList.vue";
import {useNewsItemStore} from "@/store/news-items";
import {onMounted} from "vue";
import {usePriceItemStore} from "@/store/price-items";
import environment from "@/environment";

export default {
  name: "HomePageView",
  components: {SeminarList, ClubNews, ShopList, TopBlock},
  setup() {
    const newsItemStore = useNewsItemStore();
    const priceItemStore = usePriceItemStore();
    const categories = [environment.appConfig.productCategory, environment.appConfig.merchCategory];
    const coinCategories = [environment.appConfig.coinCategory]
    onMounted( () => {
      newsItemStore.loadTopNews();
      priceItemStore.loadTopPriceItems();
    })
    return {
      categories, coinCategories
    }
  }
}
</script>

<template>
<div>
  <TopBlock/>
  <div class="listsBlock">
    <ShopList :categories="categories" caption="МАГАЗИН"/>
    <ClubNews/>
    <div>
      <SeminarList/>
      <ShopList :categories="coinCategories" caption="МОНЕТЫ"/>
    </div>

  </div>
</div>
</template>

<style scoped lang="scss">
.listsBlock {
  display: flex;
  gap: 20px;

  @include respond-to('lg') { flex-wrap: wrap; }
  @include respond-to('md') { flex-direction: column; }
}
</style>
